<template>
  <v-card>
    <v-text-field 
      class="v-input-pad"
      ref="searchInput"
      v-model="search"
      label="Search project"
      @click="stopEvent"
    />
    <v-list dense :style="{ padding: '0' }" >
      <v-list-item v-if="currentItem" color="primary">
        <v-list-item-title>{{get(currentItem, itemText)}}</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-for="item in items"
        :key="item.uuid"
        @click="setCurrent(item)"
      >
        <v-list-item-title>{{get(item, itemText)}}</v-list-item-title>
      </v-list-item>
      <v-divider v-if="currentItem || items.length"/>
      <v-list-item :to="manageLink">
        <v-list-item-title>{{manageLabel}}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import {ref} from 'vue'
import get from 'lodash/get';
import { last } from 'lodash';

const query = { $sort: { 'meta.currentAt': -1 }, $limit: 50 };

export default {
  props: {
    isActive:{
      type:Boolean,
      default:false
    },
    service: {
      type: String,
      default: 'boards',
    },
    manageLabel: {
      type: String,
      default: 'Boards Manager...',
    },
    manageLink: {
      type: String,
      default: '/tools/boards',
    },
    itemText: {
      type: String,
      default: 'name',
    },
  },
  data() {
    return {
      search:"",
      get,
    };
  },
  computed: {
    modelName() {
      return this.$FeathersVuex.api.byServicePath[this.service].modelName;
    },
    findItems() {
      if (!this.service) return () => ({ data: [] });
      return this.$store.getters[`${this.service}/find`];
    },
    currentItem() {
      let current;
      if (this.service) {
        [current] = this.$store.getters[`${this.service}/find`]({
          query: { uuid: this.$store.getters[`current${this.modelName}`] },
        }).data;
      }
      return current;
    },
    items() {
      var data=this.findItems({ query }).data
        .filter((item) => !this.currentItem || item.uuid !== this.currentItem.uuid);
      var re=new RegExp(this.search,"gi")
        
      return data.filter(o=>o.name.match(re)).slice(0,5);
    },
  },
  methods: {
    setCurrent(item) {
      return this.$store.commit(`setCurrent${this.modelName}`, item.uuid);
    },
    stopEvent(ev) {
      ev.preventDefault();
      ev.stopPropagation();
    }
  },
  mounted() {
    if (this.service) {
      this.$store.dispatch(`${this.service}/find`, { query });
    }
    var lastVal=this.isActive;
    const monitorShow=()=>{
      if (this.isActive && this.isActive!=lastVal) {
          this.$refs.searchInput.focus();
      }
      lastVal=this.isActive;
      setTimeout(()=>monitorShow(),100)
    };
    monitorShow();
  },
};
</script>
